import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Placeholder.module.scss'

interface IPlaceholderProps {
  // The block's footprint at the place it stands in for: the grid, the product page or a basket region.
  className: string
}

// Target's loader: a plain tile that pulses between white and light grey, with no shape of the content.
const Placeholder = ({ className }: IPlaceholderProps) => {
  const { t } = useSurveyLocale()

  return (
    <div
      className={`${style.tile} ${className}`}
      role="status"
      aria-label={t('questions', 'ec', 'loading')}
      data-testid="SW-EC-Placeholder"
    />
  )
}

export default Placeholder
